import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ef70663e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ef70663e&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=ef70663e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef70663e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef70663e')) {
      api.createRecord('ef70663e', component.options)
    } else {
      api.reload('ef70663e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ef70663e&scoped=true", function () {
      api.rerender('ef70663e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/integral/exchangeConfig/index.vue"
export default component.exports